<z-dropdown-menu class="profile-menu" [overlayMinWidth]="280" zAlign="end" zPush>
    <button dropdown-trigger class="user-menu__trigger" aria-label="User menu">
        <app-svg-icon name="account_circle" size="lg" />
    </button>
    <div class="profile__header">
        <img [src]="defaultAvatarPath" alt="Profile" class="profile__avatar" />
        <div class="profile__info">
            <span class="profile__name">{{ displayName }}</span>
            <span class="profile__email">{{ email }}</span>
        </div>
    </div>
    <z-divider />
    <z-dropdown-menu-item>
        <a routerLink="/profile" class="profile-menu__item">
            <app-svg-icon name="person" size="lg" />
            <span>PROFILE</span>
        </a>
    </z-dropdown-menu-item>
    @if (hasViewSettingsPermission()) {
        <z-dropdown-menu-item>
            <a routerLink="/settings" class="profile-menu__item">
                <app-svg-icon name="settings" size="lg" />
                <span>SETTINGS</span>
            </a>
        </z-dropdown-menu-item>
    }
    <z-divider />
    <z-dropdown-menu-item (click)="logout()">
        <span class="profile-menu__item">
            <app-svg-icon name="logout" size="lg" />
            <span>LOGOUT</span>
        </span>
    </z-dropdown-menu-item>
</z-dropdown-menu>
